import React, { useState } from "react";

const YEARS = Array.from({ length: 97 }, (_, i) => 1929 + i);
const COMP = [49.5, 50.9, 52.3, 52.9, 52.6, 52.0, 50.6, 51.7, 51.9, 52.4, 52.7, 51.8, 51.3, 52.8, 55.0, 56.0, 56.4, 54.1, 53.6, 52.5, 53.3, 53.0, 54.1, 55.1, 55.8, 55.3, 54.5, 55.2, 55.4, 55.1, 54.8, 55.4, 55.2, 55.0, 54.9, 54.9, 54.7, 55.6, 56.2, 56.6, 57.5, 58.4, 57.6, 57.5, 57.3, 57.7, 56.7, 56.6, 56.5, 56.6, 57.2, 57.7, 56.6, 56.8, 56.3, 55.5, 55.7, 56.5, 56.6, 56.3, 56.4, 57.0, 56.9, 57.3, 57.0, 56.1, 55.7, 55.2, 55.0, 55.7, 56.0, 56.6, 56.5, 55.8, 55.4, 55.0, 54.0, 53.4, 54.6, 55.3, 54.4, 53.0, 52.7, 52.3, 52.3, 52.2, 52.8, 53.2, 53.4, 53.3, 53.3, 54.6, 53.0, 51.7, 51.5, 51.4, 50.9];
const MANU = [15.5, 15.0, 14.1, 13.0, 13.8, 14.5, 14.5, 14.8, 15.7, 13.7, 14.7, 15.3, 16.8, 18.5, 20.0, 19.3, 17.1, 16.1, 17.2, 17.2, 16.5, 16.9, 17.3, 17.6, 18.5, 17.4, 17.5, 17.6, 17.4, 16.4, 16.7, 16.5, 16.0, 16.0, 15.8, 15.7, 15.6, 15.9, 15.7, 15.6, 15.5, 14.8, 13.9, 13.8, 13.9, 13.8, 12.7, 12.8, 12.9, 12.9, 13.0, 12.7, 12.2, 11.6, 11.2, 11.1, 10.9, 10.7, 10.3, 10.1, 9.8, 9.6, 9.3, 9.1, 8.9, 8.7, 8.6, 8.4, 8.4, 7.5, 7.3, 7.2, 6.7, 6.2, 5.9, 5.7, 5.4, 5.3, 5.2, 5.1, 4.6, 4.5, 4.5, 4.5, 4.4, 4.4, 4.4, 4.3, 4.3, 4.3, 4.2, 4.3, 4.0, 3.9, 3.9, 3.8, 3.7];
const PROF = [10.2, 7.9, 3.9, -0.3, -0.3, 3.7, 5.2, 7.3, 7.3, 5.4, 6.8, 9.4, 11.9, 12.2, 12.0, 11.1, 9.0, 7.8, 9.4, 11.0, 10.3, 11.7, 11.5, 10.4, 10.0, 9.7, 11.3, 10.4, 9.7, 8.6, 10.1, 9.5, 9.3, 10.0, 10.4, 10.7, 11.4, 11.3, 10.4, 10.3, 9.0, 7.4, 8.0, 8.5, 8.3, 7.0, 7.4, 8.5, 9.1, 9.3, 8.3, 6.7, 6.8, 5.9, 6.8, 7.5, 7.4, 6.3, 6.7, 6.9, 6.3, 5.8, 6.1, 6.4, 6.8, 7.8, 8.3, 8.8, 9.1, 8.0, 7.7, 6.6, 5.8, 7.0, 8.0, 9.2, 10.0, 10.4, 8.7, 6.6, 7.5, 9.3, 9.3, 10.1, 9.9, 10.2, 9.7, 9.2, 8.8, 9.0, 9.0, 9.3, 11.4, 11.2, 11.3, 11.3, 11.4];

const SERIES = [
  { key: "comp", data: COMP, color: "#3a3a3a", label: { it: "Redditi da lavoro dipendente, tutti i settori", en: "Compensation of employees, all sectors" } },
  { key: "manu", data: MANU, color: "#2f6fd6", label: { it: "Salari e stipendi della manifattura", en: "Manufacturing wages and salaries" } },
  { key: "prof", data: PROF, color: "#b45309", label: { it: "Profitti delle società", en: "Corporate profits" } },
];

const T = {
  it: {
    title: "Stati Uniti: salari della manifattura dal 18,5 al 3,7% del reddito, profitti all'11,4%",
    sub: "Quote sul reddito interno lordo, in percentuale, 1929-2025. Trascina il cursore o passa sul grafico; usa i due anni per il confronto.",
    year: "Anno", compare: "Confronto tra due anni", compareSub: "Scegli i due anni: le barre mostrano le tre quote e la variazione in punti.",
    yearA: "Anno A", yearB: "Anno B", change: "variazione", pts: "punti", setA: "Usa come A", setB: "Usa come B",
    presets: "Confronti rapidi", top: "Lavoro dipendente (scala 45-60%)", bottom: "Manifattura e profitti (scala -5-22%)",
    note: "Manifattura: dal 1998 nuova classificazione dei settori (NAICS), che restringe il perimetro di circa un decimo; la linea è tratteggiata nel punto di raccordo.",
    source: "Fonte: Bureau of Economic Analysis via FRED: quote del reddito interno lordo (serie A4002E1A156NBEA e A445RE1A156NBEA); salari della manifattura (A552RC1A027NBEA fino al 1997, N552RC1A027NBEA dal 1998) divisi per il reddito interno lordo (GDIA). Dati annuali 1929-2025.",
  },
  en: {
    title: "United States: manufacturing wages from 18.5% to 3.7% of income, profits at 11.4%",
    sub: "Shares of gross domestic income, percent, 1929-2025. Drag the slider or hover the chart; use the two years to compare.",
    year: "Year", compare: "Compare two years", compareSub: "Pick the two years: bars show the three shares and the change in points.",
    yearA: "Year A", yearB: "Year B", change: "change", pts: "points", setA: "Set as A", setB: "Set as B",
    presets: "Quick comparisons", top: "Compensation of employees (45-60% scale)", bottom: "Manufacturing and profits (-5-22% scale)",
    note: "Manufacturing: from 1998 a new industry classification (NAICS) narrows the perimeter by about a tenth; the line is dashed at the splice.",
    source: "Source: Bureau of Economic Analysis via FRED: shares of gross domestic income (series A4002E1A156NBEA and A445RE1A156NBEA); manufacturing wages (A552RC1A027NBEA to 1997, N552RC1A027NBEA from 1998) divided by gross domestic income (GDIA). Annual data 1929-2025.",
  },
};

const PRESETS = [[1929, 1970], [1953, 2025], [1970, 2025], [1998, 2025]];
const W = 760, PAD = { l: 44, r: 16 };
const xOf = y => PAD.l + ((y - 1929) / (2025 - 1929)) * (W - PAD.l - PAD.r);
const fmt = (v, lang, d = 1) => { const s = Number(v).toFixed(d); return lang === "it" ? s.replace(".", ",") : s; };
const sign = (v, lang) => (v > 0 ? "+" : "") + fmt(v, lang);

const Panel = ({ series, y0, y1, h, ticks, cur, dashedAt, children }) => {
  const yOf = v => 8 + (1 - (v - y0) / (y1 - y0)) * (h - 16);
  const path = (data, from = 0, to = data.length - 1) => data.slice(from, to + 1).map((v, i) => `${i ? "L" : "M"}${xOf(YEARS[from + i]).toFixed(1)},${yOf(v).toFixed(1)}`).join(" ");
  const i = YEARS.indexOf(cur);
  return (
    <svg viewBox={`0 0 ${W} ${h}`} className="isc-panel">
      {ticks.map(v => <g key={v}><line x1={PAD.l} x2={W - PAD.r} y1={yOf(v)} y2={yOf(v)} className="wpc-grid" /><text x={PAD.l - 6} y={yOf(v) + 4} textAnchor="end" className="wpc-tick">{v}</text></g>)}
      {children}
      {series.map(s => {
        const splice = dashedAt ? YEARS.indexOf(dashedAt) : -1;
        return splice > 0 && s.key === "manu" ? (
          <g key={s.key}>
            <path d={path(s.data, 0, splice - 1)} className="isc-line" style={{ stroke: s.color }} />
            <path d={path(s.data, splice - 1, splice)} className="isc-line dashed" style={{ stroke: s.color }} />
            <path d={path(s.data, splice)} className="isc-line" style={{ stroke: s.color }} />
          </g>
        ) : <path key={s.key} d={path(s.data)} className="isc-line" style={{ stroke: s.color }} />;
      })}
      <line x1={xOf(cur)} x2={xOf(cur)} y1={4} y2={h - 4} className="isc-cursor" />
      {series.map(s => <circle key={s.key} cx={xOf(cur)} cy={yOf(s.data[i])} r="5" className="isc-dot" style={{ fill: s.color }} />)}
    </svg>
  );
};

export const IncomeSharesChart = ({ lang = "it" }) => {
  const ui = T[lang] ? lang : "en";
  const t = T[ui];
  const [year, setYear] = useState(1970);
  const [hoverYear, setHoverYear] = useState(null);
  const [a, setA] = useState(1953);
  const [b, setB] = useState(2025);
  const cur = hoverYear ?? year;
  const i = YEARS.indexOf(cur), ia = YEARS.indexOf(a), ib = YEARS.indexOf(b);

  const onMove = e => {
    const r = e.currentTarget.getBoundingClientRect();
    const px = ((e.clientX - r.left) / r.width) * W;
    setHoverYear(Math.min(2025, Math.max(1929, Math.round(1929 + ((px - PAD.l) / (W - PAD.l - PAD.r)) * (2025 - 1929)))));
  };
  const band = <>{[a, b].map(y => <line key={y} x1={xOf(y)} x2={xOf(y)} y1={0} y2={400} className="isc-mark" />)}</>;

  return (
    <section className="isc wpc" data-testid="income-shares-chart" dir="ltr">
      <h3 className="wpc-title">{t.title}</h3>
      <p className="wpc-sub">{t.sub}</p>
      <div className="wpc-legend">{SERIES.map(s => <span key={s.key}><i className="wpc-swatch" style={{ background: s.color }} /> {s.label[ui]}</span>)}</div>
      <div className="isc-charts" onMouseMove={onMove} onMouseLeave={() => setHoverYear(null)} data-testid="isc-svg">
        <div className="isc-panel-label">{t.top}</div>
        <Panel series={[SERIES[0]]} y0={45} y1={60} h={150} ticks={[45, 50, 55, 60]} cur={cur}>{band}</Panel>
        <div className="isc-panel-label">{t.bottom}</div>
        <Panel series={[SERIES[1], SERIES[2]]} y0={-5} y1={22} h={190} ticks={[0, 5, 10, 15, 20]} cur={cur} dashedAt={1998}>{band}</Panel>
        <svg viewBox={`0 0 ${W} 18`} className="isc-panel">{[1930, 1950, 1970, 1990, 2010].map(y => <text key={y} x={xOf(y)} y={12} textAnchor="middle" className="wpc-tick">{y}</text>)}</svg>
      </div>
      <div className="wpc-controls">
        <div>
          <input type="range" min="1929" max="2025" step="1" value={year} onChange={e => setYear(+e.target.value)} className="wpc-slider" aria-label={t.year} data-testid="isc-slider" />
          <div className="isc-setbtns">
            <button type="button" onClick={() => setA(cur)} data-testid="isc-set-a">{t.setA}</button>
            <button type="button" onClick={() => setB(cur)} data-testid="isc-set-b">{t.setB}</button>
          </div>
        </div>
        <div className="wpc-readout" data-testid="isc-readout">
          <div className="wpc-readout-year" data-testid="isc-readout-year">{cur}</div>
          {SERIES.map(s => <div key={s.key}><span className="wpc-k" style={{ color: s.key === "comp" ? "#d9d9d9" : s.key === "manu" ? "#7fb0ff" : "#fbbf24" }}>{s.label[ui]}</span> <b>{fmt(s.data[i], ui)}%</b></div>)}
        </div>
      </div>

      <h4 className="wpc-h4">{t.compare}</h4>
      <p className="wpc-sub">{t.compareSub}</p>
      <div className="isc-presets" data-testid="isc-presets">
        <span className="wpc-toolbar-label">{t.presets}</span>
        {PRESETS.map(([pa, pb]) => (
          <button key={`${pa}-${pb}`} type="button" className={`lsc-sort ${a === pa && b === pb ? "active" : ""}`} onClick={() => { setA(pa); setB(pb); }} data-testid={`isc-preset-${pa}-${pb}`}>{pa} → {pb}</button>
        ))}
      </div>
      <div className="isc-compare" data-testid="isc-compare">
        <div className="isc-compare-head">
          <span />
          <label>{t.yearA} <input type="number" min="1929" max="2025" value={a} onChange={e => { const v = +e.target.value; if (v >= 1929 && v <= 2025) setA(v); }} data-testid="isc-year-a" /></label>
          <label>{t.yearB} <input type="number" min="1929" max="2025" value={b} onChange={e => { const v = +e.target.value; if (v >= 1929 && v <= 2025) setB(v); }} data-testid="isc-year-b" /></label>
          <span className="wpc-ratio">{t.change}</span>
        </div>
        {SERIES.map(s => {
          const va = s.data[ia], vb = s.data[ib], max = 60;
          return (
            <div key={s.key} className="isc-compare-row" data-testid={`isc-compare-${s.key}`}>
              <span className="isc-compare-label">{s.label[ui]}</span>
              <span className="wpc-bar" style={{ width: `${(Math.max(va, 0) / max) * 72}%`, background: s.color, opacity: 0.55 }}><em>{fmt(va, ui)}%</em></span>
              <span className="wpc-bar" style={{ width: `${(Math.max(vb, 0) / max) * 72}%`, background: s.color }}><em>{fmt(vb, ui)}%</em></span>
              <span className="wpc-ratio" style={{ color: vb - va < 0 ? "#b42318" : "#0b7a3b" }}>{sign(vb - va, ui)} {t.pts}</span>
            </div>
          );
        })}
      </div>
      <p className="wpc-note">{t.note}</p>
      <p className="wpc-note">{t.source}</p>
    </section>
  );
};

export default IncomeSharesChart;
